import { render, staticRenderFns } from "./invite.vue?vue&type=template&id=6ff9ee8c&scoped=true&"
import script from "./invite.vue?vue&type=script&lang=js&"
export * from "./invite.vue?vue&type=script&lang=js&"
import style0 from "./invite.vue?vue&type=style&index=0&id=6ff9ee8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff9ee8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ff9ee8c')) {
      api.createRecord('6ff9ee8c', component.options)
    } else {
      api.reload('6ff9ee8c', component.options)
    }
    module.hot.accept("./invite.vue?vue&type=template&id=6ff9ee8c&scoped=true&", function () {
      api.rerender('6ff9ee8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/mining/invite/invite.vue"
export default component.exports